import React, { useCallback, useState } from "react";
import { Box, Card, Flex, Text } from "rebass";
import { FaRegArrowAltCircleUp } from "react-icons/fa";

import { CreateRecord } from "./CreateRecord";
import { Dropbox } from "./Dropbox";
import { FileSystem } from "./FileSystem";
import { GoogleDrive } from "./GoogleDrive";
import { RadioButton } from "./components/RadioButton";

import { AlphaBetAltSVG } from "../svg/AlphaBetAltSVG";
import { DropboxSVG } from "../svg/DropboxSVG";
import { GoogleDriveSVG } from "../svg/GoogleDriveSVG";

import { ImportType } from "./types";

const MAX_SIZE = 26;

const buttonList = [
  { id: ImportType.computerUpload, title: "Computer Upload", Icon: FaRegArrowAltCircleUp, size: MAX_SIZE, },
  { id: ImportType.writtenText, title: "Written Text", Icon: AlphaBetAltSVG, size: MAX_SIZE, },
  { id: ImportType.googleDrive, title: "Google Drive", Icon: GoogleDriveSVG, size: 24, },
  { id: ImportType.dropbox, title: "Dropbox", Icon: DropboxSVG, size: MAX_SIZE, }
];

const componentCollection = {
  [ImportType.computerUpload]: FileSystem,
  [ImportType.dropbox]: Dropbox,
  [ImportType.googleDrive]: GoogleDrive,
  [ImportType.writtenText]: CreateRecord,
};

const Modal: React.FC = () => {
  const [importType, setImportType] = useState(ImportType.computerUpload);
  const changeImportType = useCallback((event) => {
    const { currentTarget: { value } } = event;

    setImportType(value as ImportType);
  }, []);
  const Component = componentCollection[importType];

  return (
    <Flex
      width="57rem"
      height="37.5rem"
    >
      <Card
        height="100%"
        width={0.3}
        py="130px"
        borderRight="2px solid"
        borderRightColor="sp-gray"
        bg="sp-gray2"
      >
        <Flex
          height="100%"
          flexDirection={"column"}
        >
          {
            buttonList.map(({ id, title, Icon, size }) => {
              const gap = 0.5 * (MAX_SIZE - size);

              return (
                <RadioButton
                  key={id}
                  value={id}
                  borderRadius={0}
                  bg="transparent"
                  isActive={id === importType}
                  onClick={changeImportType}
                >
                  <Box
                    my={`${gap}px`}
                    mr={`${gap + 18}px`}
                    ml={`${gap}px`}
                    color="sp-blue"
                  >
                    <Icon size={size} display="block" />
                  </Box>

                  <Text fontSize="16px">{title}</Text>
                </RadioButton>
              );
            })
          }
        </Flex>
      </Card>

      <Box
        flex={1}
        css="overflow: hidden;"
        bg="#fff"
      >
        <Component />
      </Box>
    </Flex>
  );
};

export default Modal;
